import script from "./VUserSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./VUserSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__